import { inject, Injectable } from '@angular/core';
import { DpButtonStateIcon, DpFieldButton, DpFieldCheckbox, DpFieldText, DpFormRow, DpSection, DpSectionForm, DpSectionIcon } from '@docpath/webcomponents';
import { faCog } from '@fortawesome/free-solid-svg-icons';

import { AppService } from '../models/services-config';
import { ServicesHttpService } from './services-http.service';

@Injectable({
    providedIn: 'root'
})
export class ServicesFormService {

    private readonly i18nPrefix = 'services-config.aim.form';

    private readonly servicesHttpService = inject(ServicesHttpService);

    getSectionForm(): DpSectionForm {
        return new DpSectionForm({
            sections: [this.getAimSection(), this.getGeneralSection()],
            i18nPrefix: 'services-config.aim.form',
            ignoreDisabledOrHiddenFields: true,
            sectionIcon: new DpSectionIcon(faCog)
        });
    }

    private getAimSection(): DpSection {
        return new DpSection({
            name: AppService.Aim,
            rows: [
                new DpFormRow([
                    new DpFieldText({
                        name: 'url',
                        required: true,
                        column: 3,
                        labelColumn: 2,
                        placeholder: `${this.i18nPrefix}.url.placeholder.aim`
                    }),
                    new DpFieldText({
                        name: 'token',
                        required: true,
                        column: 3,
                        labelColumn: 1,
                        placeholder: `${this.i18nPrefix}.token.placeholder.aim`
                    }),
                    new DpFieldButton({
                        name: 'test',
                        click: (fieldButton, form) => this.testAimConnection(fieldButton, form as DpSectionForm),
                        stateIcons: true,
                        labelHidden: true,
                        column: 3,
                        requiredFields: ['url', 'token']
                    })
                ])
            ]
        });
    }

    private getGeneralSection(): DpSection {
        return new DpSection({
            name: 'general',
            rows: [
                new DpFormRow([
                    new DpFieldCheckbox({
                        name: 'automatic',
                        column: 3,
                        hidden: true
                    })
                ])
            ],
            hiddenHeader: true
        });
    }

    private testAimConnection(testButton: DpFieldButton, form: DpSectionForm) {
        const aimConfig = form.getValue().aim;
        const { url, token } = aimConfig;

        testButton.state = DpButtonStateIcon.Loading;

        this.servicesHttpService.testAimConnection(url, token).subscribe(response => {
            testButton.state = response.result ? DpButtonStateIcon.Success : DpButtonStateIcon.Error;
        });
    }

}
